export default __webpack_public_path__ + "static/media/dis.2771e932.jpg";